
import { Vue, Component, Prop } from 'vue-property-decorator';
import { TransformedCutoffTimesItem } from '@/features/cutoff-times/types';
import { getCarrierLogoCode, getDisplayCarrierCode } from '@/features/common/helpers/carrier';

@Component
export default class CutoffResultsItem extends Vue {
  @Prop({ required: true }) item!: TransformedCutoffTimesItem;

  get carrierLogoCode(): string {
    return getCarrierLogoCode(this.item.carrierCode, this.item.selectedService || '');
  }

  get displayCarrierCode(): string {
    return getDisplayCarrierCode(this.item.carrierCode, this.item.selectedService || '');
  }

  get firstServiceLevelIsPickupAvailable(): boolean {
    return this.item.selectedServices[0].isPickupAvailable;
  }

  get firstLevelCutoffTime(): string {
    return this.item.selectedServices[0].cutoffTime;
  }

  get serviceLevelsHaveSameTime(): boolean {
    return this.item.selectedServices
      .every((serviceLevel) => this.firstLevelCutoffTime === serviceLevel.cutoffTime);
  }
}
